import React from "react";
import style from "./index.module.scss";
import Status from "./components/Status";
import { Tooltip } from "antd";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { StuVote, StuVoteStatus } from "API/vote";
import moment from "moment";
import useDeviceType from "Utils/useDeviceType";

interface ListItemProps {
    basename: string;
    data: StuVote;
}

export default function ListItem({ basename, data }: ListItemProps) {
    const { isPC } = useDeviceType();

    return (
        <div className={classNames(style.root, style[`type${data.type}`])}>
            <h1 className={style.title}>
                <Tooltip title={data.title}>{data.title}</Tooltip>

                {isPC && <Status status={data.voteStatus} />}
            </h1>

            <div className={style.info}>
                {data.startTime && (
                    <span>
                        开始时间{moment(data.startTime).format("MM-DD HH:mm")}
                    </span>
                )}
                {data.endTime && (
                    <span>
                        {" "}
                        ｜ 结束时间{moment(data.endTime).format("MM-DD HH:mm")}
                    </span>
                )}
            </div>

            <div className={style.tools}>
                {data.voteStatus === StuVoteStatus.Idle && (
                    <Link to={`${basename}/vote/${data.id}`}>前往参与</Link>
                )}
                {data.voteStatus !== StuVoteStatus.Idle && (
                    <Link to={`${basename}/vote/${data.id}`}>查看活动</Link>
                )}
            </div>

            {!isPC && <Status status={data.voteStatus} />}
        </div>
    );
}
